import React from "react";
import { getComment, getCommentById, downloadCommentById, addComment } from "../services/api";
import useLocalStorage from "../useLocalStorage";

const CommentBox = ({ data }) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [commentList, setCommentList] = React.useState([]);
  const [message, setMessage] = React.useState();
  const { ls } = useLocalStorage();
  const { userName } = ls;

  const fetchComment = async (id) => {
    setIsLoading(true);
    const response = await getComment(id);
    //get first item when found if not found setData === undefined

    if (response) {
      response.Data.forEach((element) => {
        let date = new Date(element.LastModified);
        element.stringDate = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
      });
      setCommentList(response.Data);
    }

    document.getElementById("txtMsg").focus();

    setIsLoading(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  React.useEffect(() => {
    fetchComment(data.RegId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const attachFile = (e) => {
    const reader = new FileReader();
    reader.onloadend = async () => {
      const base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      let param = {
        Module: "AST_Reg",
        ModuleId: data.RegId,
        Message: "",
        File: base64String,
        FileInfo: {
          FileName: e.target.files[0].name,
          FileExtension: e.target.files[0].type,
        },
        UserModified: userName,
      };
      await addComment(param);
      await fetchComment(data.RegId, true);
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  const enterSendComment = async (e) => {
    let key = e.key;
    if (key === "Enter") {
      if (!e.shiftKey) {
        e.preventDefault();
        setIsLoading(true);
        let param = {
          Module: "AST_Reg",
          ModuleId: data.RegId,
          Message: message,
          UserModified: userName,
        };
        await addComment(param);
        await fetchComment(data.RegId, true);
        setMessage("");
      }
    }
  };

  const sendComment = async (e) => {
    if (message) {
      let param = {
        Module: "AST_Reg",
        ModuleId: data.RegId,
        Message: message,
        UserModified: userName,
      };
      await addComment(param);
      await fetchComment(data.RegId, true);
      setMessage("");
    }
  };

  function do_resize(e) {
    var maxrows = 5;
    var txt = e.target.value;
    var cols = e.target.cols;

    var arraytxt = txt.split("\n");
    var rows = arraytxt.length;

    for (var i = 0; i < arraytxt.length; i++) rows += parseInt(arraytxt[i].length / cols);

    if (rows > maxrows) e.target.rows = maxrows;
    else e.target.rows = rows;
  }

  const Downloadlink = ({ item }) => {
    const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
      const byteCharacters = window.atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    };

    const clickFile = async (id, file) => {
      if (file.FileExtension.search("image") !== -1) {
        //view image
        const r = await getCommentById(id);
        if (r.File) {
          const blob = b64toBlob(r.File, item.FileInfo.FileExtension);
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, "_blank").focus();
        }
      } else {
        //view downloadfile
        const blob = await downloadCommentById(id);
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, file.FileName);
        } else {
          const a = document.createElement("a");
          document.body.appendChild(a);
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = file.FileName;
          a.click();
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
          }, 0);
        }
      }
    };

    return (
      <div style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => clickFile(item.Id, item.FileInfo)}>
        {item.FileInfo.FileName}
      </div>
    );
  };

  return (
    <section className="chatbox-popup fixed z-50 bottom-20 right-2">
      <header className="chatbox-popup__header">
        <aside className="flex-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-20 w-20 chatbox-popup__avatar p-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
            />
          </svg>
        </aside>
        <aside className="flex-8">
          <h1>{userName}</h1>AssetId : {data.RegId}
        </aside>
        <aside className="flex-1">
          <button className="chatbox-maximize">
            <i className="fa fa-window-maximize" aria-hidden="true"></i>
          </button>
        </aside>
      </header>
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        <main className="chatbox-popup__main">
          <div>
            {commentList.map((item, idx) => {
              return (
                <div
                  key={idx}
                  className={
                    item.UserModified === userName ? "chatbox__messageBox text-right" : "chatbox__messageBox text-left"
                  }
                >
                  <div className={item.UserModified === userName ? "message-box currentUser" : "message-box"}>
                    {item.Message && item.Message !== "" ? item.Message : <Downloadlink item={item} />}
                    <div
                      className={
                        item.UserModified === userName
                          ? "chatbox__tooltip chatbox__tooltip--left"
                          : "chatbox__tooltip chatbox__tooltip--right"
                      }
                    >
                      {item.stringDate}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </main>
      )}
      <footer className="chatbox-popup__footer">
        <div>
          <label htmlFor="FileInfo">
            <aside className="flex-1 text-center mr-2 -mt-2 cursor-pointer">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                />
              </svg>
            </aside>
          </label>
          <input
            id="FileInfo"
            name="FileInfo"
            type="file"
            //accept="image/png, image/gif, image/jpeg"
            accept="image/*"
            style={{ display: "none" }}
            onChange={(e) => {
              attachFile(e);
            }}
            //capture="environment"
            webkitdirectory
            mozdirectory
            directory
          />
        </div>
        <aside style={{ flex: 10 }}>
          <textarea
            id="txtMsg"
            className="textAreaComment"
            type="text"
            placeholder="Type your message here..."
            value={message}
            onKeyPress={(e) => enterSendComment}
            onKeyUp={(e) => do_resize(e)}
            onChange={(e) => {
              setMessage(e.target.value);
            }}
            rows="1"
          ></textarea>
        </aside>
        <aside
          className="flex-1 text-center transform rotate-45 ml-2 -mt-2 cursor-pointer"
          onClick={(e) => sendComment(e)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
          </svg>
        </aside>
      </footer>
    </section>
  );
};

export default CommentBox;
